import type { User as AuthUser, IdTokenResult } from 'firebase/auth'
import logger from '~/src/lib/logger'

const ONE_MINUTE_IN_MILLISECONDS = 60 * 1000
let eventEmitter: any | undefined

const shouldForceRefresh = (expirationTime: string): boolean => {
  return (
    Date.now() + ONE_MINUTE_IN_MILLISECONDS > new Date(expirationTime).valueOf()
  )
}

const getUserToken = async (
  authUser: AuthUser | undefined | null,
  forceRefresh = false
): Promise<IdTokenResult | undefined> => {
  if (!authUser) {
    return undefined
  }

  try {
    const idTokenResult = await authUser.getIdTokenResult(forceRefresh)

    if (eventEmitter && eventEmitter.listenerCount('message') === 0) {
      eventEmitter = undefined
    }

    if (!forceRefresh && shouldForceRefresh(idTokenResult.expirationTime)) {
      return await authUser.getIdTokenResult(true)
    }

    return idTokenResult
  } catch (err) {
    logger.error('[getUserToken] Error getting user token', { err })
    return undefined
  }
}

export default getUserToken
